export class FindAllScopePatternNumberListRequest {
    makeName?: string;
 
}